import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

const detectDefaultLanguage = (): string => {
  const storedLanguage = localStorage.getItem("user-language");
  if (storedLanguage && ["en", "es", "pt"].includes(storedLanguage)) {
    return storedLanguage;
  }

  const systemLanguage = navigator.language || navigator.languages?.[0] || "en";
  const languageCode = systemLanguage.split("-")[0];

  if (["en", "es", "pt"].includes(languageCode)) {
    return languageCode;
  }

  return "en";
};

const defaultLanguage = detectDefaultLanguage();

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init({
    debug: false,
    fallbackLng: "en",
    lng: defaultLanguage,
    fallbackNS: "common",
  });
